import { Component, OnInit } from '@angular/core';
import { CommonServiceService } from '../../../component/common/common-service.service';
import { SharedService } from '../../../component/shared/shared.service';
import { ActivatedRoute } from '@angular/router';
import { User } from '../../user/model/user';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { UserDetail } from '../../user/model/user-detail';
import { UserService } from '../../user/service/user.service';
import { Appointment, Schedule, Reschedule } from '../model/appointment';
import { AppointmentService } from '../service/appointment.service';
import { UtilityService } from '../calendar/utility.service';
import { DialogAction, ActionMessage } from '../../../shared/enum/dialog-action.enum'; 
import { Service } from '../../master/model/service';
import { ServiceMasterService } from '../../master/services/service-master.service';
import { Patient } from '../../patient/model/patient';
import { PatientService } from '../../patient/service/patient-service.service';
import { TimeslotMasterService } from '../../master/services/timeslot-master.service';
import { AuthServiceService } from '../../../component/service/auth-service.service';
@Component({
  selector: 'app-view-appointment',
  templateUrl: './view-appointment.component.html',
  styleUrls: ['./view-appointment.component.css'] ,
  providers:[CommonServiceService]
})
export class ViewAppointmentComponent implements OnInit {
  authService : AuthServiceService;
    private currentDate = "";
    Userloading : boolean;
    schedulrloading : boolean = false;
    Users : UserDetail[] = null;
    message : string = '';
    usrData: UserDetail  ;
    clinics : any;
    user: User;
    private sub: any;
    AppointmentSlotId: number = null;
    color:string = 'doc-list hoverList';
    defaultStyle:string = 'doc-list outList';
    hoveredDivId :number;
    appointment : Appointment ;
    bookingappointment : Appointment ;
    selectedAppointment : Appointment;
    appointments :Appointment[];
    dayAppointments :Appointment[]; 
    schedules : Appointment[];
    isErrorMessage : boolean;
    appDate: any ;
    rescheduleDate : any;
    isReschedule : boolean = false;
    isSuccessMessage : boolean = false;
    private _restCommonService : CommonServiceService;
    calendarOptions:Object;
    taskAvailable : object;
    selectedType: object;
    scheduleData : Schedule[];
    reschedulrloading:boolean = false;
    patients : Patient[];
    patientList : Patient[];
    patient : Patient;
    flag : boolean = false;
    services : Service[];
    patientName : string="";
    isNew: boolean = false;
    isBooking:boolean = false;
    timeslot: any[] = [];
    selectedTime = "";
    isSuperAdmin : boolean = false;
    isDoctor : boolean = false;
    isBDA : boolean = false;
    isAssistant : boolean = false;
    userD: any;
     dtOptions: IMyDpOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
    };
  constructor( authorizationService : AuthServiceService,commService : CommonServiceService, private _sharedService: SharedService, private _usrService : UserService, private _appService : AppointmentService,private route: ActivatedRoute, private _utility: UtilityService, public _ptService : PatientService, public _srvService : ServiceMasterService) {
       this.currentDate = commService.getCurrentDate();
       let dt = new Date();
       this.appDate =  { date: { year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() } };
       this.rescheduleDate =  { date: { year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() } };
       this.appointment  =  new  Appointment(null,null,'',null,'',null,'',null,'','',null,'','','',null,'',false,'',false,'','','','','',false,false, '',0.0); 
       this.bookingappointment  =  new  Appointment(null,null,'',null,'',null,'',null,'','',null,'','','',null,'',false,'',false,'','','','','',false,false, '', 0.0);
       this.authService = authorizationService;
      
       _sharedService.bookingEmitted$.subscribe(
        text => {
            this.getdata(this.selectedType);
          
        });
        _sharedService.yesEmitted$.subscribe(
          text => {
              if(text.Action===DialogAction.DELETE.toString()  && text.Page === 'APPOINTMENTCALCANCEL') {
                
                this.cancelAppointmentData(text.Data);
              }  
          });
   }
 
  getScheduleForMonth() {
    let month = new Date();
    this.getAppointmentForMonth(month.getMonth() + 1,month.getFullYear()) ;
  }

  initProcesss() {
    var id : number;
    this.sub = this.route.params.subscribe(params => {
      id = +params['id'];
      this.getUsers(id);
      this.searchAppointment();
    });
     
    
  }

  ngOnInit() {
    if(this.authService.getUserRole() === "1") {
      this.isSuperAdmin = true;
   } else if(this.authService.getUserRole() === "2") {
     this.isDoctor = true;
   } else if(this.authService.getUserRole() === "3") {
    this.isAssistant = true;
  } else if(this.authService.getUserRole() === "4") {
    this.isBDA = true;
  }    
    this.user = JSON.parse(sessionStorage.getItem("User"));
    if(this.user=== undefined || this.user=== null) {
      this._usrService.getUserProfile().subscribe(data=>{
        if(data !== null && data.length>0) {
        
          this.user = data[0];
          
          this.initProcesss();
       } else {
        sessionStorage.clear();
        window.location.href="/#/login";
       }
       
     },error => {
      sessionStorage.clear();
      window.location.href="/#/login";
     })
    } else {
      this.initProcesss();
    }
    
  }
   ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
  searchAppointment() {
    
    
    if(this.appDate.date != null && this.appDate.year != 0) {
      let startDate = this.appDate.date.year + '/' + this.appDate.date.month + '/'+ this.appDate.date.day;
      let endDate = startDate;

      this._appService.getDoctorAppointment( startDate, endDate).subscribe(
        data => { 
          this.dayAppointments = data;   
        },
        error => {  this.schedulrloading = false;}
    );
      
    }
    else {
      //this.message = 'Please select appointment date!'; 
      //this.isErrorMessage = true;
      return;
    }
   
  }
  showClinic() {
    if(this.appointment.AppointmentDoctorId==0) {
      if(this.selectedType !== undefined && this.selectedType !== null) {
        this.getdata(this.selectedType);
      } else {
        let month = new Date();
      //  this.getAppointmentForMonth(month.getMonth() + 1,month.getFullYear()) ;
      }
     
    } else {
      this.getSlot(this.appointment.AppointmentDoctorId); 
    let docId = this.appointment.AppointmentDoctorId.toString();
    var data = this.Users.filter(function(user){
      return (user.UserId === parseInt(docId));
    })
    if(data.length>0){
      this.clinics = data[0].UserClinic;
      //if(this.clinics.length>0) {
        this.appointment.AppointmentClinicId = 0;
        if(this.selectedType !== undefined && this.selectedType !== null) {
          this.getdata(this.selectedType);
        } else {
          let month = new Date();
          this.getAppointmentForMonth(month.getMonth() + 1,month.getFullYear()) ;
        }
       
      //}
    } 
  }
  }
  getAppointmentFoDay(date : string) {
    if(this.appointment.AppointmentDoctorId != null && this.appointment.AppointmentDoctorId != 0)
    {
          if( this.appointment.AppointmentClinicId==null)
          {
            this.appointment.AppointmentClinicId = 0;
          }
          this._appService.getDoctorAppointmentForDateRange( this.appointment.AppointmentDoctorId, this.appointment.AppointmentClinicId, date,date).subscribe(
            data => { 
              this.appointments = data;
              var event : any[]=[]
              this.appointments.forEach(element => {
                
                event.push({'TaskId' : element.AppointmentPatientId,'TaskName' : element.AppointmentPatientName, 'Time' : element.AppointmentTime, 'Color' : element.DoctorColorCode })
              });
                
              this.taskAvailable = { "Days": [ {"date" : date.split('-')[2] + '-' +this._utility.monthShortNames[parseInt(date.split('-')[1])-1]+ '-' + date.split('-')[0], "tasks" : event}]};
              this.schedulrloading = false;
              this.message = ""; 
            },
            error => { 
              this.taskAvailable = { "Days": [ {"date" : date.split('-')[2] + '-' +this._utility.monthShortNames[parseInt(date.split('-')[1]) - 1]+ '-' + date.split('-')[0], "tasks" : []}]};
            }
        );
        this.getScheduleForDays(date, date);
    } else {
        this._appService.getDoctorAppointment( date,date).subscribe(
          data => { 
            this.appointments = data;
            var event : any[]=[]
            this.appointments.forEach(element => {
              
              event.push({'TaskId' : element.AppointmentPatientId,'TaskName' : element.AppointmentPatientName, 'Time' : element.AppointmentTime, 'Color' : element.DoctorColorCode})
            });
              
            this.taskAvailable = { "Days": [ {"date" : date.split('-')[2] + '-' +this._utility.monthShortNames[parseInt(date.split('-')[1])-1]+ '-' + date.split('-')[0], "tasks" : event}]};
           debugger;
            this.schedulrloading = false;
            this.message = ""; 
          },
          error => { 
            this.taskAvailable = { "Days": [ {"date" : date.split('-')[2] + '-' +this._utility.monthShortNames[parseInt(date.split('-')[1]) - 1]+ '-' + date.split('-')[0], "tasks" : []}]};
          }
      );
      }
  }

  getAppointmentForWeek(startDate : string, endDate : string) {
    if(this.appointment.AppointmentDoctorId != null && this.appointment.AppointmentDoctorId != 0)
    {
      if( this.appointment.AppointmentClinicId==null )
      {
        this.appointment.AppointmentClinicId = 0;
      }
        this._appService.getDoctorAppointmentForDateRange(this.appointment.AppointmentDoctorId,this.appointment.AppointmentClinicId,  startDate, endDate).subscribe(
          data => { 
            this.appointments = data;
            var event : any[]=[]
            this.appointments.forEach(element => {
                  event.push({'TaskId' : element.AppointmentPatientId,'TaskName' : element.AppointmentPatientName, 'Time' : element.AppointmentTime, "date" : element.AppointmentDay, 'Color' : element.DoctorColorCode})
            });
            var taskList = [];
            let list = event.map(item => item.date).filter((value, index, self) => self.indexOf(value) === index)
              for(let taskItem of list)
              {
                let tasks =  event.filter( (days) => days.date=== taskItem );
                  taskList.push({"date" : taskItem.split('-')[2] + '-' +this._utility.monthShortNames[parseInt(taskItem.split('-')[1]) - 1]+ '-' + taskItem.split('-')[0], "tasks" : tasks})
              }
              this.taskAvailable = { "Days": taskList};
            this.schedulrloading = false;
            this.message = ""; 
          },
          error => {  this.schedulrloading = false;}
      );
      this.getScheduleForDays(startDate, endDate);
    } else {
      this._appService.getDoctorAppointment( startDate, endDate).subscribe(
        data => { 
          this.appointments = data;
          var event : any[]=[]
          this.appointments.forEach(element => {
                event.push({'TaskId' : element.AppointmentPatientId,'TaskName' : element.AppointmentPatientName, 'Time' : element.AppointmentTime, "date" : element.AppointmentDay, 'Color' : element.DoctorColorCode})
          });
          var taskList = [];
          let list = event.map(item => item.date).filter((value, index, self) => self.indexOf(value) === index)
            for(let taskItem of list)
            {
              let tasks =  event.filter( (days) => days.date=== taskItem );
                taskList.push({"date" : taskItem.split('-')[2] + '-' +this._utility.monthShortNames[parseInt(taskItem.split('-')[1]) - 1]+ '-' + taskItem.split('-')[0], "tasks" : tasks})
            }
            this.taskAvailable = { "Days": taskList};
          this.schedulrloading = false;
          this.message = ""; 
        },
        error => {  this.schedulrloading = false;}
    );
    }
  }
  getScheduleForDays(startDate : string, endDate : string) {
    if(this.appointment.AppointmentDoctorId != null && this.appointment.AppointmentDoctorId != 0)
    {
      let clinic = 0;
      if( this.appointment.AppointmentClinicId==null ) {
         clinic =   this.clinics[0].AssociateClinicId;
      } else {
        clinic = this.appointment.AppointmentClinicId;
      }
     this._appService.getDoctorScheduleForMultipleDay(this.appointment.AppointmentDoctorId,clinic,startDate, endDate).subscribe(
        data=> {
          this.scheduleData = data ;
        },
        error=>{
          
        }
      );
    }
}
  getAppointmentForMonth(month : number, year : number) {

    let startDate =year.toString() +'-' + month.toString() + '-01';
    var lastDay = new Date(year,month, 0);
    let endDate =  year.toString() +'-' + (lastDay.getMonth() + 1).toString() + '-'+lastDay.getDate();
    this.taskAvailable = { "Days": []};
    if(this.appointment.AppointmentDoctorId != null && this.appointment.AppointmentDoctorId != 0 )
    {
      if( this.appointment.AppointmentClinicId==null)
      {
        this.appointment.AppointmentClinicId = 0;
      }
        this._appService.getDoctorAppointmentForDateRange(this.appointment.AppointmentDoctorId,this.appointment.AppointmentClinicId,  startDate, endDate).subscribe(
          data => { 
            this.appointments = data;
            var event : any[]=[]
            this.appointments.forEach(element => {
                  event.push({'TaskId' : element.AppointmentPatientId,'TaskName' : element.AppointmentPatientName, 'Time' : element.AppointmentTime, "date" : element.AppointmentDay, 'Color' : element.DoctorColorCode})
            });
            var taskList = [];
            let list = event.map(item => item.date).filter((value, index, self) => self.indexOf(value) === index)
              for(let taskItem of list)
              {
                let tasks =  event.filter( (days) => days.date=== taskItem );
                  taskList.push({"date" : taskItem.split('-')[2] + '-' +this._utility.monthShortNames[parseInt(taskItem.split('-')[1]) - 1]+ '-' + taskItem.split('-')[0], "tasks" : tasks})
              }
              this.taskAvailable = { "Days": taskList};
            this.schedulrloading = false;
            this.message = ""; 
          },
          error => {  this.schedulrloading = false;}
      );
    } else {
        this._appService.getDoctorAppointment( startDate, endDate).subscribe(
          data => { 
            this.appointments = data;
            var event : any[]=[]
            this.appointments.forEach(element => {
                  event.push({'TaskId' : element.AppointmentPatientId,'TaskName' : element.AppointmentPatientName, 'Time' : element.AppointmentTime, "date" : element.AppointmentDay, 'Color' : element.DoctorColorCode})
            });
            var taskList = [];
            let list = event.map(item => item.date).filter((value, index, self) => self.indexOf(value) === index)
              for(let taskItem of list)
              {
                let tasks =  event.filter( (days) => days.date=== taskItem );
                  taskList.push({"date" : taskItem.split('-')[2] + '-' +this._utility.monthShortNames[parseInt(taskItem.split('-')[1]) - 1]+ '-' + taskItem.split('-')[0], "tasks" : tasks})
              }
              this.taskAvailable = { "Days": taskList};
            this.schedulrloading = false;
            this.message = ""; 
          },
          error => {  this.schedulrloading = false;
            
          }
      );
      }
  }

  getUsers(id : number) : void {
    this.Userloading = true;
    this._usrService.getUsersDetail().subscribe( data=> {
     
     // this.Users  = data;
     if(this.user !== null ) {
       if(this.user.UserRoleId==2) {
          this.Users = data;//.filter((usr) => usr.UserRoleId < 3 && usr.UserId=== this.user.UserId )
          if(id !== undefined && id !== null && !isNaN(id)){
            var data = this.Users.filter(function(user){
              return (user.UserId === id);
            })
           
            if(data.length>0){
              this.usrData = data[0];
              this.appointment.AppointmentDoctorId = this.usrData.UserId;
              //this.showClinic();
            } 

          } else {
           // if(this.user.UserRoleId<3) {
              let uId = this.user.UserId;
              var data = this.Users.filter(function(user){
                return (user.UserId ===  uId);
              })
             
              if(data.length>0){
                this.usrData = data[0];
                this.appointment.AppointmentDoctorId = this.usrData.UserId;
              //  this.showClinic();
                this.getService(this.usrData.SpecializationId);
              } 
           // }
          }
        } else {
          this.Users = data;//.filter((usr) => usr.UserRoleId < 3 )
          if(id != undefined && id != null &&    !isNaN(id)){
            var data = this.Users.filter(function(user){
              return (user.UserId === id);
            })
            if(data.length>0){
              this.usrData = data[0];
              this.appointment.AppointmentDoctorId = this.usrData.UserId;
            //  this.showClinic();
              this.getService(this.usrData.SpecializationId);
            } 

          } else {
            this.appointment.AppointmentDoctorId = 0;
          }
        }
        
      }
      this.Userloading = false;
    },
    error=>{
        this.Userloading = false;
        this.message = error.data;
    });
  }
  getdata(data : any) {
 
    if(data.type=="M") {
      this.getAppointmentForMonth(data.selected.split('/')[0], data.selected.split('/')[1])
    } else if(data.type=="W") {
       this.getAppointmentForWeek(data.selected.split(' ')[0], data.selected.split(' ')[1]);
    } else {
       this.getAppointmentFoDay(data.selected);
    }
    this.selectedType = data;
  }
  bookAppointment() {
    this._sharedService.overlay( {'module' :'USER','type' : 'Appointment','isShow' : true,'data' : null, 'secondData' : null});
  }

  onDateChanged(event: IMyDateModel) {
    //debugger;
    
    if(event.date != null && event.date.year != 0) {
      let date = event.date.year + '/' + event.date.month + '/'+ event.date.day;
     
      if(this.selectedAppointment.AppointmentDoctorId !== undefined && this.selectedAppointment.AppointmentDoctorId !== null && this.selectedAppointment.AppointmentDoctorId !== 0){
        this.schedulrloading = true;
        this.showScheduleDate(date);
      }
      
    }
    else {
      //this.message = 'Please select appointment date!'; 
      //this.isErrorMessage = true;
      return;
    }
  }
  onDateBookingChanged(event: IMyDateModel) {
    //debugger;
    
    if(event.date != null && event.date.year != 0) {
      let date = event.date.year + '/' + event.date.month + '/'+ event.date.day;
     
      if(this.bookingappointment.AppointmentDoctorId !== undefined && this.bookingappointment.AppointmentDoctorId !== null && this.bookingappointment.AppointmentDoctorId !== 0){
        this.schedulrloading = true;
        this.selectedAppointment = this.bookingappointment;
        this.showScheduleDate(date);
      }
      
    }
    else {
      //this.message = 'Please select appointment date!'; 
      //this.isErrorMessage = true;
      return;
    }
  }
  getScheduleForDay() {
    this.schedules = [];
    
   
    if(this.rescheduleDate === null) {
      this.message = 'Please select appointment date!'; 
      this.isErrorMessage = true;
      return;
    }
   
    this.schedulrloading = true;
    var d = this.rescheduleDate.date.day;
    if(d.length==1){
      d = '0'+ this.rescheduleDate.date.day;
    }
    var m = this.rescheduleDate.date.month;
    if(d.length==1){
      m = '0'+ this.rescheduleDate.date.month;
    }
    let date = this.rescheduleDate.date.year + '/' + m + '/'+ d;
    this.schedulrloading = true;
    this.showScheduleDate(date);
  }
  showScheduleDate(date : string) {
     
        this._appService.getDoctorScheduleForDay(this.selectedAppointment.AppointmentDoctorId, this.selectedAppointment.AppointmentClinicId, date).subscribe(
          data => { 
            this.schedules = data.filter(function(slot){
              return (slot.AppointmentIsCancelled == true || slot.AppointmentIsBooked === false) 
            });

            if(this.selectedTime !=="") {
              
              let slot = this.schedules.filter(item=> item.AppointmentSlotDescription === this.selectedTime);
              this.selectedTime = "";
              if(slot != undefined && slot.length>0) {
                this.bookingappointment.AppointmentSlotId = slot[0].AppointmentSlotId;
              }
            }
            this.schedulrloading = false;
            this.message = ""; 
          },
          error => {  this.schedulrloading = false;}
      );
     
  }

  cancelReschedule() {
    this.isReschedule = false;
  }
  reschedulAppointment(appData : Appointment) {
    this.isReschedule = true;
    let dt = new Date();
    this.AppointmentSlotId = null;
    this.rescheduleDate =  { date: { year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() } };
    this.selectedAppointment =appData;
    this.getScheduleForDay();
  }
  saveReschedulAppointment() {
    let appData = this.selectedAppointment;
    if(appData !== undefined) {
     let day = appData.AppointmentDay;
     let time = appData.AppointmentTime ;
     // this._appService.rescheduleSchedule(appData.AppointmentDoctorId, appData.AppointmentClinicId, appData.AppointmentDay, appData.AppointmentTime ).subscribe(data=>{
        var d = this.rescheduleDate.date.day;
    if(d.toString().length==1){
      d = '0'+ this.rescheduleDate.date.day;
    }
    var m = this.rescheduleDate.date.month;
    debugger;
    if(m.toString().length==1){
      m = '0'+ this.rescheduleDate.date.month;
    }
    let date = this.rescheduleDate.date.year + '-' + m + '-'+ d;
        appData.AppointmentDay = date;
        appData.AppointmentSlotId = this.AppointmentSlotId;
        var slotId  = this.AppointmentSlotId.toString();
        let slotData = this.schedules.filter(function(user){
          return (user.AppointmentSlotId === parseInt(slotId));
        })
        if(slotData.length>0){
          appData.AppointmentTime = slotData[0].AppointmentTime;
        } 
        this.reschedulrloading = true;
        let rescedule:Reschedule = new  Reschedule(day,time, appData);
      
        this._appService.rescheduleSchedule(rescedule).subscribe(data=>{
          this.reschedulrloading = false;
          this.isSuccessMessage = true;
          this.isReschedule = false;
          this.getdata(this.selectedType);
          let dt = new Date();
          this.appDate =  { date: { year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() } };
          this.searchAppointment();
          this.message = "Appointment canceled successfully";
        }, error=> {
          this.reschedulrloading = false;
          this.isErrorMessage = true;
           this.message = "Appointment not canceled";
            
        })     
    }
  }
  cancelAppointmentData(appData : Appointment) {
    if(appData !== undefined) {
     
      this._appService.cancelAppointment(appData.AppointmentDoctorId, appData.AppointmentClinicId, appData.AppointmentDay, appData.AppointmentTime ).subscribe(data=>{
          this.isSuccessMessage = true;
          this.getdata(this.selectedType);
          this.message = "Appointment canceled successfully";
          this.searchAppointment();
          
      }, error=> {
        this.isErrorMessage = true;
         this.message = "Appointment not canceled";
          
      })
    }
    
 }
  cancelAppointment(data : Appointment) {
    this.selectedAppointment =data;
    this._sharedService.emitDialog(true, "Deactivate", ActionMessage.CANCEL.toString(),true,DialogAction.DELETE.toString(), 'APPOINTMENTCALCANCEL', this.selectedAppointment);  

  }
  searchClient(term: string): void {  
    
    this.flag = false;  
    if(term.length>2 && this.isNew===false) {
      //if(sessionStorage.getItem("data") == undefined) {
        this._ptService.getPatientForSearch('All', term.toUpperCase()).subscribe( data=> {
            this.patientList = data;
            if(this.patientList.length>0) {
              this.flag = true; 
              document.getElementById('search-result').className = "search-result search-result-open";
            }
            this.patients = [];
            
          },
          error=>{
              
          });
  
    }
   
  }
  getService(id: number) {
    this._srvService.getServiceDetail(id).subscribe(data => {
         this.services = data;
    }, error => {
     
    })
  }
  showDocClinic() {
    let docId = this.bookingappointment.AppointmentDoctorId.toString();
    var data = this.Users.filter(function(user){
      return (user.UserId === parseInt(docId));
    })
    if(data.length>0){
      this.clinics = data[0].UserClinic;
      if(this.clinics.length>0) {
        this.bookingappointment.AppointmentClinicId = this.clinics[0].AssociateClinicId;
        this.selectedAppointment = this.bookingappointment;
        this.getScheduleForDay() ;
      }
    } 
  }
  setDefault(evt) {
    evt.stopPropagation();
  }
  onselectClient(ClientObj) {    
    if(ClientObj !== null) { 
      if (ClientObj.AppointmentPatientId != 0) {  
        let  client= ClientObj.PatientFirstName + ' '+ ClientObj.PatientLastName + '-'+ ClientObj.Patient_PIN  
        this.patientName =    client; 
        this.bookingappointment.AppointmentPatientId = ClientObj.PatientId;
        if(ClientObj.PatientEmailAddress !== null && ClientObj.PatientEmailAddress !== "null") {
          this.bookingappointment.AppointmentPatientMail = ClientObj.PatientEmailAddress;
        }
        if(ClientObj.PatientPrimaryMobNo !== null && ClientObj.PatientPrimaryMobNo !== "null") {
          this.bookingappointment.AppointmentPatientContactNo = ClientObj.PatientPrimaryMobNo;
        }
        this.flag = false;  
      }  
      else {  
        this.flag = false;  
      }  
    } else {
      this.isNew = true;
      this.flag = false; 
    }
  }
  clear() : void {
    this.bookingappointment.AppointmentDoctorId = null;
    this.bookingappointment.AppointmentClinicId = null;
    this.bookingappointment.AppointmentServiceId = null;
    this.bookingappointment.AppointmentPatientId = null;
    this.bookingappointment.AppointmentSlotId = null;
    this.isNew = false;
    let dt = new Date();
    this.rescheduleDate =  { date: { year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() } };
    var d = this.rescheduleDate.date.day.toString();
    if(d.toString().length == 1){
      d = '0'+ this.rescheduleDate.date.day.toString();
    }
    var m = this.rescheduleDate.date.month.toString();
    if(m.toString().length == 1){
      m = '0'+ this.rescheduleDate.date.month.toString();
    }
    let date = this.rescheduleDate.date.year + '/' + m + '/'+ d;
    this.appointment.AppointmentDay = date;
    this.bookingappointment.AppointmentPatientContactNo= null;
    this.bookingappointment.AppointmentPatientMail = "";
    this.bookingappointment.AppointmentPatientName = "";
    this.patientName = "";
    this.isBooking = false;
    this.isNew = false;
  } 
  saveAppointment(): void {
    if(this.bookingappointment.AppointmentDoctorId === null) {
      this.message = 'Please select Expert!'; 
      this.isErrorMessage = true;
      return;
    }
    if(this.bookingappointment.AppointmentClinicId === null) {
      this.message = 'Please select clinic!'; 
      this.isErrorMessage = true;
      return;
    }
    if(this.bookingappointment.AppointmentSlotId === null) {
      this.message = 'Please select time slot!'; 
      this.isErrorMessage = true;
      return;
    }
    /*if(this.bookingappointment.AppointmentPatientId === null) {
      this.message = 'Please select patient!'; 
      this.isErrorMessage = true;
      return;
    }*/
    if(this.bookingappointment.AppointmentServiceId === null) {
      this.message = 'Please select service!'; 
      this.isErrorMessage = true;
      return;
    }
    this.Userloading = true;
   
    if(this.bookingappointment.AppointmentPatientId !== null) {
        let patientId = this.bookingappointment.AppointmentPatientId.toString();
        if(this.patientList.length>0) {
            var data = this.patientList.filter(function(user){
              return (user.PatientId === parseInt(patientId));
          })
          if(data.length>0){
            this.bookingappointment.AppointmentPatientName = data[0].PatientFirstName + ' ' + data[0].PatientLastName;
            this.bookingappointment.AppointmentPatientMail = data[0].PatientEmailAddress;
            this.bookingappointment.AppointmentPatientContactNo = data[0].PatientPrimaryMobNo;
          } 
        } else {
            this.bookingappointment.AppointmentPatientName = this.patient.PatientFirstName + ' ' + this.patient.PatientLastName;
            this.bookingappointment.AppointmentPatientMail = this.patient.PatientEmailAddress;
            this.bookingappointment.AppointmentPatientContactNo = this.patient.PatientPrimaryMobNo;
        }
    } else {
        this.bookingappointment.AppointmentPatientName = this.patientName;
         
        if(this.bookingappointment.AppointmentPatientContactNo.toString() =="") {
          this.bookingappointment.AppointmentPatientContactNo = 0;
        }
        
    }
    this.patients = [];
    var slotId  =  this.bookingappointment.AppointmentSlotId.toString();
    let slotData = this.schedules.filter(function(user){
      return (user.AppointmentSlotId === parseInt(slotId));
   })
   if(slotData !== null && slotData.length>0){
      this.bookingappointment.AppointmentTime = slotData[0].AppointmentTime;
    }
    var srvId  =  this.bookingappointment.AppointmentServiceId.toString();
    let serviceData = this.services.filter(function(user){
      return (user.ServiceId === parseInt(srvId));
   })
   if(serviceData.length>0){
      this.bookingappointment.AppointmentServiceName = serviceData[0].ServiceName;
    }
    var d = this.rescheduleDate.date.day.toString();
    if(d.toString().length==1){
      d = '0'+ this.rescheduleDate.date.day.toString();
    }
    var m = this.rescheduleDate.date.month.toString();
    if(m.toString().length==1){
      m = '0'+ this.rescheduleDate.date.month.toString();
    }
    let date = this.rescheduleDate.date.year + '-' + m + '-'+ d;
    this.bookingappointment.AppointmentDay = date;
    this._appService.appointmentData = this.bookingappointment;
    this.reschedulrloading = true;
     this._appService.saveAppointment().subscribe(
       data => {
         this.message = "Appointment saved successfully!";
        this.isSuccessMessage = true;
        this.isErrorMessage = false;
          this.Userloading = false;
          this.isNew = false;
          this.hideMessage();
          let dt = new Date();
          this.rescheduleDate =  { date: { year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() } };
          this.reschedulrloading = false;
          this.getdata(this.selectedType);
          
          this.appDate =  { date: { year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() } };
          this.searchAppointment();
       },
       erorr => {
        this.message = erorr.data;
        this.isSuccessMessage = false;
        this.isErrorMessage = true;
        let dt = new Date();
        this.rescheduleDate =  { date: { year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() } };
        this.reschedulrloading = false;
        this.isNew = false;
       }
      );
  };
  hideMessage() : void {
    setTimeout(() => {
      this.isErrorMessage  = false;
      this.isSuccessMessage  = false;   
      this.message = '';
       this.isBooking = false;
       
    }, 100);
  }

  getSlot(id: number) {
   
     
      this._appService.getTimeSlots(id).subscribe(data=>{
          this.timeslot = data;         
      }, error=> {
        
      })

   }

   booking(data: any) {
      let dt = new Date(data.date);
      this.isBooking = true;
      this.selectedTime = data.time;
      this.rescheduleDate =  { date: { year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() } };
      if(this.appointment.AppointmentDoctorId !== undefined && this.appointment.AppointmentDoctorId !== 0) {
        this.bookingappointment.AppointmentDoctorId= this.appointment.AppointmentDoctorId;
        this.showDocClinic()
      }
   }
}



// WEBPACK FOOTER //
// ./src/app/section/appointment/view-appointment/view-appointment.component.ts